import React, { Component } from "react";
import CommentCard from "./commentCard";
import CommentForm from "./commentForm";
import { Row, Col } from "react-bootstrap";
import { createComment, getCommentsByReview } from "../services/commentService";
import { getAnswers, getBinaryAnswers } from "../services/answerService";
import moment from "moment";
// import Reaction from "./common/reaction";

class ReviewCard extends Component {
  state = {
    text: "",
    commentFormVisible: false,
    commentsVisible: false,
    comments: [],
    reactions: { likeIsActive: false, dislikeIsActive: false },
  };

  scrollToCommentForm = () => {
    this.commentFormRef.scrollIntoView({
      behavior: "smooth",
    });
  };

  handleReply(currentComment) {
    const text = `@${currentComment.userName} ${this.state.text}`;
    this.scrollToCommentForm();
    this.setState({ text: text });
  }

  handleTextChange = (e) => {
    this.setState({ text: e.target.value });
  };

  render() {
    const { review, instituteID, currentUser, fields } = this.props;
    const { comments } = this.state;

    const answers = getAnswers();
    const binaryAnswers = getBinaryAnswers();
    return (
      <div style={{ marginTop: 50 }}>
        <div className="media ">
          <div className="media-body">
            {/* <h5 className="media-heading">{review.userName}</h5> */}

            <Row className="show-grid">
              <Col sm={2} md={2}>
                {<i className="fa fa-user-md" aria-hidden="true"></i>}
                {fields[[review.field]].name}
              </Col>

              {review.tuition ? (
                <Col sm={2} md={2}>
                  {<i className="fa fa-money" aria-hidden="true"></i>}
                  {review.tuition + "KZ"}
                </Col>
              ) : null}
            </Row>

            <Row className="show-grid">
              {review.programQuality ? (
                <Col sm={2} md={2}>
                  {<i className="fa fa-book" aria-hidden="true"></i>}
                  {`Programa: ${review.programQuality}`}
                </Col>
              ) : null}
              {review.professorsQuality ? (
                <Col sm={2} md={2}>
                  {<i className="fa fa-pencil" aria-hidden="true"></i>}
                  {`Ensino dos profs: ${review.professorsQuality}`}
                </Col>
              ) : null}
              {review.professorsEthics ? (
                <Col sm={2} md={2}>
                  {<i className="fa fa-user-circle" aria-hidden="true"></i>}
                  {`Ética dos profs: ${review.professorsEthics}`}
                </Col>
              ) : null}
              {review.administrationQuality ? (
                <Col sm={2} md={2}>
                  {<i className="fa fa-users" aria-hidden="true"></i>}
                  {`Direção: ${review.administrationQuality}`}
                </Col>
              ) : null}
              {review.facilitiesQuality ? (
                <Col sm={2} md={2}>
                  {<i className="fa fa-university" aria-hidden="true"></i>}
                  {`Infra-estruturas: ${review.facilitiesQuality}`}
                </Col>
              ) : null}
              {review.facilitiesHigiene ? (
                <Col sm={2} md={2}>
                  {<i className="fa fa-bath" aria-hidden="true"></i>}
                  {`Higiene: ${review.facilitiesHigiene}`}
                </Col>
              ) : null}
              {review.security ? (
                <Col sm={2} md={2}>
                  {<i className="fa fa-shield" aria-hidden="true"></i>}
                  {`Segurança: ${review.security}`}
                </Col>
              ) : null}
              {review.tutorQuality ? (
                <Col sm={2} md={2}>
                  {<i className="fa fa-user-circle-o" aria-hidden="true"></i>}
                  {`Qualidade do tutor: ${review.tutorQuality}`}
                </Col>
              ) : null}

              {review.graduationTime ? (
                <Col sm={2} md={2}>
                  {<i className="fa fa-graduation-cap" aria-hidden="true"></i>}
                  {`Graduação: ${review.graduationTime} anos`}
                </Col>
              ) : null}
              {review.diplomaTime ? (
                <Col sm={2} md={2}>
                  {<i className="fa fa-file" aria-hidden="true"></i>}
                  {`Diploma: ${review.diplomaTime} meses`}
                </Col>
              ) : null}
              {review.allowsSeeingExams ? (
                <Col sm={2} md={2}>
                  {<i className="fa fa-file-text" aria-hidden="true"></i>}
                  {`Deixam ver provas: ${
                    answers[review.allowsSeeingExams].name
                  }`}
                </Col>
              ) : null}
              {review.hasInternet ? (
                <Col sm={2} md={2}>
                  {<i className="fa fa-globe" aria-hidden="true"></i>}
                  {`Tem internet: ${answers[review.hasInternet].name}`}
                </Col>
              ) : null}
              {review.hasRunningWater ? (
                <Col sm={2} md={2}>
                  {<i className="fa fa-tint" aria-hidden="true"></i>}
                  {`Água corrente: ${answers[review.hasRunningWater].name}`}
                </Col>
              ) : null}
              {review.hasAC ? (
                <Col sm={2} md={2}>
                  {<i className="fa fa-snowflake-o" aria-hidden="true"></i>}
                  {`Tem AC: ${answers[review.hasAC].name}`}
                </Col>
              ) : null}
              {review.hasSexualHarassment ? (
                <Col sm={2} md={2}>
                  {<i className="fa fa-venus-mars" aria-hidden="true"></i>}
                  {`Assédio sexual: ${
                    binaryAnswers[review.hasSexualHarassment].name
                  }`}
                </Col>
              ) : null}
              {review.hasCorruption ? (
                <Col sm={2} md={2}>
                  {<i className="fa fa-user-secret" aria-hidden="true"></i>}
                  {`Corrupção: ${binaryAnswers[review.hasCorruption].name}`}
                </Col>
              ) : null}
              {review.hasInternship ? (
                <Col sm={2} md={2}>
                  {<i className="fa fa-briefcase" aria-hidden="true"></i>}
                  {`Estágio: ${binaryAnswers[review.hasInternship].name}`}
                </Col>
              ) : null}
              {review.endorsement ? (
                <Col sm={2} md={2}>
                  {<i className="fa fa-thumbs-up" aria-hidden="true"></i>}
                  {`Aconselha: ${binaryAnswers[review.endorsement].name}`}
                </Col>
              ) : null}
            </Row>

            <p>{review.text}</p>
            <ul className="list-unstyled list-inline media-detail pull-left">
              <li>
                <i className="fa fa-calendar" />
                {moment(review.createdAt.toDate().toString()).format(
                  "YYYY/MM/DD HH:mm:ss"
                )}
                {/* <Reaction
                  onClick={() => {
                    const reactions = { ...this.state.reactions };
                    reactions.likeIsActive = !reactions.likeIsActive;
                    // reactions.dislikeIsActive = !reactions.dislikeIsActive;
                    this.setState({ reactions });
                  }}
                  isActive={this.state.reactionIsActive}
                  activeIcon={"fa fa-heart"}
                  inactiveIcon={"fa fa-heart-o"}
                /> */}
              </li>

              <li className="">
                <button
                  type="button"
                  className="btn btn-link"
                  onClick={() => {
                    if (this.state.commentFormVisible)
                      this.scrollToCommentForm();
                    this.setState({ commentFormVisible: true });
                  }}
                >
                  Comentar
                </button>

                <button
                  type="button"
                  className="btn btn-link"
                  onClick={async () => {
                    const comments = await getCommentsByReview(
                      instituteID,
                      review.id
                    );
                    this.setState({
                      commentsVisible: !this.state.commentsVisible,
                      comments: comments,
                    });
                  }}
                >
                  {!this.state.commentsVisible ? (
                    <div>Ver Comentários</div>
                  ) : (
                    <div>Esconder Comentários</div>
                  )}
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div style={{ marginLeft: 50 }}>
          {this.state.commentsVisible && comments
            ? comments.map((comment) => {
                return (
                  <CommentCard
                    key={comment.id}
                    data={comment}
                    onReply={() => this.handleReply(comment)}
                  />
                );
              })
            : null}

          {this.state.commentFormVisible || this.state.commentsVisible ? (
            <div
              ref={(el) => {
                this.commentFormRef = el;
              }}
            >
              <CommentForm
                value={this.state.text}
                onChange={this.handleTextChange}
                onSubmit={async () => {
                  await createComment(
                    { text: this.state.text },
                    currentUser,
                    instituteID,
                    review.id
                  );
                  const comments = await getCommentsByReview(
                    instituteID,
                    review.id
                  );

                  this.setState({ comments, text: "" });
                }}
                onCancel={() => {
                  this.setState({ commentFormVisible: false, text: "" });
                }}
                height={null}
              />
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default ReviewCard;
